import {QuickStartItemVariant} from '../components/QuickStartItem';

export const AVAILABLE_VARIANTS = [
  QuickStartItemVariant.Low,
  QuickStartItemVariant.Standard,
  QuickStartItemVariant.Maximum,
];
